import { t } from '@lingui/macro';
import { TGetStateResponseCompanyDE } from 'lendingApi/lapiOverrides.types';

export const DE_LEGAL_FORM_VALUES: TGetStateResponseCompanyDE['type'][] = [
  'freiberufler',
  'gewerbebetrieb',
  'gewerbebetrieb_eingtr',
  'ek',
  'eg',
  'gbr',
  'ohg',
  'kg',
  'partnerschaft',
  'gemeinnuetziger_verein',
  'nicht_gemeinnuetziger_verein',
  'ug',
  'gmbh',
  'gmbh_u_co_kg',
  'aktiengesellschaft',
  'ltd',
  'kgaa',
  'andere',
];

export const MONTHS = () => [
  { value: '01', label: t`January` },
  { value: '02', label: t`February` },
  { value: '03', label: t`March` },
  { value: '04', label: t`April` },
  { value: '05', label: t`May` },
  { value: '06', label: t`June` },
  { value: '07', label: t`July` },
  { value: '08', label: t`August` },
  { value: '09', label: t`September` },
  { value: '10', label: t`October` },
  { value: '11', label: t`November` },
  { value: '12', label: t`December` },
];

export const REQUESTED_AMOUNT_CONTACT_THRESHOLD = 350000;

export const EMPTY_ADDRESS = {
  house_number: '',
  house_name: '',
  street_line_1: '',
  street_line_2: '',
  town: '',
  postcode: '',
  equifax_token: '',
  residential_status: undefined,
};
